<template>
  <div class="game-list">
    <el-table 
      :data="games" 
      v-loading="loading"
      stripe
      border
      style="width: 100%"
    >
      <el-table-column label="游戏Logo" width="100">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.logoUrl"
            :src="scope.row.logoUrl"
            :preview-src-list="[scope.row.logoUrl]"
            style="width: 60px; height: 60px"
            fit="cover"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div v-else class="no-image">
            <i class="el-icon-picture-outline"></i>
          </div>
        </template>
      </el-table-column>
      
      <el-table-column prop="gameName" label="游戏名称" min-width="120"></el-table-column>
      
      <el-table-column prop="platform" label="平台" width="120">
        <template slot-scope="scope">
          <el-tag size="small" type="info">{{ scope.row.platform }}</el-tag>
        </template>
      </el-table-column>
      
      <el-table-column prop="dimension" label="维度" width="80">
        <template slot-scope="scope">
          <el-tag size="small" :type="scope.row.dimension === '3D' ? 'success' : 'primary'">
            {{ scope.row.dimension }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column prop="category" label="分类" width="120">
        <template slot-scope="scope">
          <el-tag size="small" type="warning">{{ scope.row.category }}</el-tag>
        </template>
      </el-table-column>
      
      <el-table-column prop="gameLibrary" label="游戏库" width="120"></el-table-column>
      
      <el-table-column label="游戏链接" min-width="150">
        <template slot-scope="scope">
          <el-link 
            v-if="scope.row.gameUrl" 
            :href="scope.row.gameUrl" 
            target="_blank" 
            type="primary"
          >
            访问游戏
          </el-link>
          <span v-else>-</span>
        </template>
      </el-table-column>
      
      <el-table-column label="描述" min-width="150">
        <template slot-scope="scope">
          <el-tooltip 
            v-if="scope.row.description" 
            :content="scope.row.description" 
            placement="top"
          >
            <span class="description-text">{{ scope.row.description }}</span>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button 
            size="mini" 
            type="primary" 
            @click="$emit('edit', scope.row)"
          >
            编辑
          </el-button>
          <el-button 
            size="mini" 
            type="danger" 
            @click="$emit('delete', scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 空状态 -->
    <div v-if="!loading && games.length === 0" class="empty-state">
      <el-empty description="暂无游戏数据"></el-empty>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameList',
  props: {
    games: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.game-list {
  background: white;
  border-radius: 4px;
  overflow: hidden;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 20px;
}

.no-image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  background: #f5f7fa;
  color: #c0c4cc;
  font-size: 20px;
  border-radius: 4px;
}

.description-text {
  display: block;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-state {
  padding: 40px;
  text-align: center;
}

/* Element UI表格样式调整 */
.el-table {
  font-size: 14px;
}

.el-table th {
  background-color: #fafafa;
  font-weight: 600;
}

.el-table td {
  padding: 12px 0;
}

.el-button--mini {
  padding: 5px 10px;
  font-size: 12px;
}

.el-tag {
  font-size: 12px;
}

.el-link {
  font-size: 12px;
}
</style>
